import { createStore } from './store/index'
import { debounce, includes, isArray } from 'lodash'
import { events } from './bus'
import axios from 'axios'
import Vue from 'vue'

const store = createStore(window.route)

const Helpers = {
  install(Vue) {
    Vue.prototype.$uploadFiles = async function (
      files,
      module,
      uniqueFolderId,
    ) {
      if (files.length == 0) return

      // Proceed folders
      this.$store.commit('PROCESSING_FOLDER', false)

      // Create new folder
      /*      if (module && !uniqueFolderId) {
        this.$store.dispatch('proceedFolder', {
          module: module
        })
      }*/

      //if (!this.$checkFileMimetype(files) || !this.$checkUploadLimit(files))
      //return // Push items to file queue

      if (!store.getters.isProcessingFolder) {
        ;[...files].map((item) => {
          this.$store.commit('ADD_FILES_TO_QUEUE', {
            parent_id: uniqueFolderId,
            file: item,
          })
        })

        // Start uploading if uploading process isn't running
        if (this.$store.getters.filesInQueueTotal == 0)
          this.$handleUploading(store.getters.fileQueue[0])

        // Increase total files in upload bar
        this.$store.commit('INCREASE_FILES_IN_QUEUES_TOTAL', files.length)
      }

      /*      } else {
        this.$store.commit('PROCESSING_FOLDER', false)
        //if (!store.getters.isProcessingFolder) {
        ;[...files].map(item => {
          this.$store.commit('ADD_FILES_TO_QUEUE', {
            parent_id: store.getters.currentFolder.unique_id,
            file: item
          })
        })

        // Start uploading if uploading process isn't running
        if (this.$store.getters.filesInQueueTotal == 0)
          this.$handleUploading(store.getters.fileQueue[0])

        // Increase total files in upload bar
        this.$store.commit('INCREASE_FILES_IN_QUEUES_TOTAL', files.length)
      }*/
      //}
    }

    Vue.prototype.$downloadFile = async function (url, opts = {}) {
      const normalized =
        typeof opts === 'string' ? { filename: opts } : opts || {}
      const { filename, onProgress } = normalized
      try {
        // Prefer cookie token (latest from backend), then Vuex/localStorage
        const cookieToken =
          typeof document !== 'undefined' && document.cookie
            ? decodeURIComponent(
                (document.cookie.match(/(?:^|; )token=([^;]*)/) || [])[1] || '',
              )
            : ''
        const storedToken =
          (store?.getters && store.getters.token) ||
          localStorage.getItem('token') ||
          ''
        const token = cookieToken || storedToken

        const response = await axios.get(url, {
          responseType: 'blob',
          withCredentials: true,
          headers: {
            ...(token ? { Authorization: 'Bearer ' + token } : {}),
          },
          onDownloadProgress: (event) => {
            if (typeof onProgress === 'function') {
              if (event && event.total) {
                const pct = Math.round((event.loaded / event.total) * 100)
                onProgress(pct)
              } else {
                onProgress(null)
              }
            }
          },
        })

        // Try to derive filename from headers if not provided
        let resolvedName = filename
        const disposition =
          response.headers?.['content-disposition'] ||
          response.headers?.['Content-Disposition'] ||
          ''
        if (!resolvedName && disposition) {
          const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(
            disposition,
          )
          if (match) {
            const raw = (match[1] || match[2]).trim()
            try {
              resolvedName = decodeURIComponent(raw)
            } catch (e) {
              resolvedName = raw
            }
          }
        }

        if (!resolvedName) {
          // Fallback to URL path segment
          try {
            const u = new URL(url, window.location?.href)
            resolvedName = u.pathname.split('/').pop() || 'download'
          } catch (e) {
            resolvedName = 'download'
          }
        }

        const blob = new Blob([response.data])
        const link = document.createElement('a')
        const href = URL.createObjectURL(blob)
        link.href = href
        link.download = resolvedName
        document.body.appendChild(link)
        link.click()
        URL.revokeObjectURL(href)
        document.body.removeChild(link)
        return true
      } catch (error) {
        // Fallback: try native anchor navigation (may carry session cookies)
        try {
          const anchor = document.createElement('a')
          anchor.href = url
          anchor.rel = 'noopener'
          document.body.appendChild(anchor)
          anchor.click()
          document.body.removeChild(anchor)
        } catch (e) {
          // Notify if even fallback failed
          events.$emit('alert:open', {
            emoji: '❌',
            title: 'Atsisiųsti nepavyko',
            message: 'Nepavyko atsisiųsti failo.',
          })
        }
        throw error
      }
    }

    Vue.prototype.$showDownloadInProgress = function (id) {
      let fileStatusClass = document.getElementById('file-item-status-' + id)
      fileStatusClass.classList.add('show-status')
    }

    Vue.prototype.$hideDownloadInProgress = function (id) {
      let fileStatusClass = document.getElementById('file-item-status-' + id)
      fileStatusClass.classList.remove('show-status')
    }

    Vue.prototype.$handleUploading = async function (item) {
      // Create ceil
      let size = 12800000,
        chunksCeil = Math.ceil(item.file.size / size),
        chunks = []

      // Create chunks
      for (let i = 0; i < chunksCeil; i++) {
        chunks.push(
          item.file.slice(
            i * size,
            Math.min(i * size + size, item.file.size),
            item.file.type,
          ),
        )
      }

      // Set Data
      let formData = new FormData(),
        uploadedSize = 0,
        isNotGeneralError = true,
        striped_name = item.file.name.replace(
          /[^A-Za-z0-9 .,"!?@#$%^&*()\-_=+;:<>/\\|{}[\]`~]*/g,
          '',
        ),
        filename =
          Array(16)
            .fill(0)
            .map((x) => Math.random().toString(36).charAt(2))
            .join('') +
          '-' +
          striped_name +
          '.part'

      do {
        let isLast = chunks.length === 1,
          chunk = chunks.shift(),
          attempts = 0

        // Set form data
        formData.set('file', chunk, filename)
        formData.set('parent_id', item.parent_id)
        formData.set('is_last', isLast)

        // Upload chunks
        do {
          await store
            .dispatch('uploadFiles', {
              form: formData,
              fileSize: item.file.size,
              totalUploadedSize: uploadedSize,
            })
            .then(() => {
              uploadedSize = uploadedSize + chunk.size
            })
            .catch((error) => {
              // Count attempts
              attempts++

              // Show Error
              if (attempts === 3) this.$isSomethingWrong()

              // Break uploading process
              if ([500, 415].includes(error.response.status))
                isNotGeneralError = false
            })
        } while (isNotGeneralError && attempts !== 0 && attempts !== 3)
      } while (isNotGeneralError && chunks.length !== 0)
    }

    Vue.prototype.$elementEqualHeight = function (selector) {
      const elements = document.querySelectorAll(selector)
      if (!elements.length) return

      // reset heights first
      elements.forEach((el) => {
        el.style.height = 'auto'
      })

      // find max height
      const maxHeight = Math.max(
        ...Array.from(elements).map((el) => el.offsetHeight),
      )

      // apply max height to all
      /*      elements.forEach((el) => {
        el.style.height = `${maxHeight}px`
      })*/
    }

    Vue.prototype.$isMobile = function () {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
      ]

      return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem)
      })
    }

    Vue.prototype.$checkOS = function () {
      // Handle styled scrollbar for Windows
      if (navigator.userAgent.indexOf('Windows') != -1) {
        let body = document.body
        body.classList.add('windows')
      }
    }

    Vue.prototype.$isApple = function () {
      const toMatch = [
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /iOS/i,
        /macOS/i,
        /Macintosh/i,
      ]

      // Check if device is iOS
      return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem)
      })
    }
  },
}

export default Helpers
